import React from "react";
import { Modify } from "src/@types/common";
import { Text } from ".";

type CardProcessProps = Modify<
  React.ComponentPropsWithoutRef<"div">,
  {
    title: string;
    description: string;
    imageSrc: string;
  }
>;

const CardProcess: React.FC<CardProcessProps> = (props) => {
  const { title, description, imageSrc, ...restProps } = props;

  return (
    <React.Fragment>
      <div className="card-process__step" {...restProps}>
        <div className="card-process__image">
          <img src={imageSrc} alt={title} />
        </div>
        <div className="card-process__body">
          <div className="card-process__title">
            <Text
              fontFamily={["Roboto", "Lexend"]}
              fontWeight={["700", "700"]}
              fontSize={["16px", "18px"]}
              lineHeight={["24px", "24px"]}
              letterSpacing={["normal", "0.5%"]}
              textAlign={["center", "center"]}
            >
              {title}
            </Text>
          </div>
          <Text
            fontFamily={["Roboto", "Roboto"]}
            fontWeight={["400", "400"]}
            fontSize={["14px", "16px"]}
            lineHeight={["20px", "24px"]}
            letterSpacing={["0.16px", "normal"]}
            textAlign={["center", "center"]}
          >
            {description}
          </Text>
        </div>
      </div>
      <style jsx scoped>{`
        .card-process__step {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          min-width: 160px;
          width: 160px;
          height: 270px;
          padding: 16px 8px;
          gap: 16px;
          border-radius: 8px;
          background: #ffffff;
          box-shadow: 0px 2px 12px 0px #7d7d7d40;
        }

        .card-process__step .card-process__image img {
          width: 64px;
          height: auto;
        }

        .card-process__step .card-process__body {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .card-process__step .card-process__title {
          height: 48px;
        }

        @media only screen and (min-width: 480px) {
          .card-process__step {
            width: 248px;
            height: 315px;
            padding: 32px 12px;
            gap: 32px;
            border-radius: 8px;
            box-shadow: 0px 2px 12px 0px #7d7d7d40;
          }

          .card-process__step .card-process__image img {
            width: 80px;
            height: auto;
          }

          .card-process__step .card-process__body {
            gap: 12px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default CardProcess;
